import { useEffect } from 'react';

const CrispChat = () => {
  useEffect(() => {
    // Crisp configuration
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = "2be89264-6e51-4dbb-9436-7251d8ea31f9";

    // Hide the bubble by default — opened on demand via the sidebar button
    window.$crisp.push(["do", "chat:hide"]);
    window.$crisp.push(["on", "session:loaded", () => {
      window.$crisp.push(["do", "chat:hide"]);
    }]);
    window.$crisp.push(["on", "chat:closed", () => {
      window.$crisp.push(["do", "chat:hide"]);
    }]);

    // Create and inject the Crisp script
    const script = document.createElement("script");
    script.src = "https://client.crisp.chat/l.js";
    script.async = true;

    // Add script to head
    document.head.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      // Remove the script element
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }

      // Clean up Crisp variables
      if (window.$crisp) {
        delete window.$crisp;
      }
      if (window.CRISP_WEBSITE_ID) {
        delete window.CRISP_WEBSITE_ID;
      }

      // Remove any Crisp-related DOM elements
      const crispElements = document.querySelectorAll('[id^="crisp"], [class*="crisp"]');
      crispElements.forEach(element => {
        if (element.parentNode) {
          element.parentNode.removeChild(element);
        }
      });
    };
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default CrispChat;
